import { Icon } from '@shopify/polaris';
import { Box, ListItemButton } from '@mui/material';

export default function NavItem({ item, active, onClick, ...other }) {
  const { icon, selectedIcon, label } = item;

  return (
    <ListItemButton
      disableGutters
      title={label}
      sx={{
        backgroundColor: active ? 'var(--p-color-nav-bg-surface-selected)' : 'inherit',
        borderRadius: 'var(--p-border-radius-200)',
        p: 'var(--p-space-200)',
        display: 'flex',
        justifyContent: 'flex-start',
        mx: '12px',
      }}
      onClick={onClick}
      {...other}
    >
      <Box
        display="flex"
        alignItems={'center'}
        height={'1.2rem'}
        sx={{ width: '20px', flexShrink: 0 }}
      >
        {selectedIcon && icon && <Icon source={active ? selectedIcon : icon} />}
      </Box>
    </ListItemButton>
  );
}
